<template>
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Login</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <form id="login_form" method="POST" action="/login" aria-label="Login">

                        <input type="hidden" name="_token" :value="csrf_token">

                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="email"
                                    v-validate="'required|max:255'"
                                    data-vv-name="email"

                                    label="Email"
                                    name="email"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="password"
                                    v-validate="'required|min:6'"
                                    data-vv-name="password"

                                    label="Password"
                                    name="password"
                                    type="password"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="password_confirmation"
                                    v-validate="'required|min:6'"
                                    data-vv-name="password"

                                    label="Password confirmation"
                                    name="password_confirmation"
                                    type="password"></v-text-field>
                            </v-flex>
                        </v-layout>

                        <v-btn @click="login" color="primary">Login</v-btn>
                        <router-link :to="{name: 'auth.email'}">Forgot Password?</router-link>
                    </form>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "Login",

        data: () => ({
            email: '',
            password: '',
            password_confirmation: ''
        }),

        computed: {
            csrf_token() {
                let token = document.head.querySelector('meta[name="csrf-token"]')
                return token.content
            }
        },

        methods: {
            login() {
                axios.post('http://manager.britishpedia.test/api/auth/register',
                    { email: this.email, password: this.password, password_confirmation: this.password_confirmation })
                    .then(
                        (response) => {
                            console.log(response)
                        }
                    )
                    .catch(
                        (error) => console.log(error)
                    )
            }
        }

    };
</script>
